export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لم يتم العثور على المستخدم"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اختر"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إغلاق"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بحث"])}
}